import * as api from "../api";

export const getComments = (postId) => async (dispatch) => {
    try {
      const { data } = await api.fetchComments(postId); 
        dispatch({ type: 'FETCH_COMMENTS', payload: data, postId }); 
      console.log("FETCHED comments:", data);
    } catch (error) {
      console.error("Error fetching comments:", error.message);
    }
};
export const createComment = (values, setLoading, clear) => async (dispatch) => {
    try {
        setLoading(true)
        const { data } = await api.createComment(values);
        dispatch({ type: 'ADD_COMMENT', payload: data });
        // dispatch(getPosts())
        setLoading(false)
        alert("Comment created successfully. Refresh your browser to view post")
        clear()

    } catch (error) {
        setLoading(true)
        alert('Ohpps, unable to create new post due to an error.')
        console.log(error)
    }
}